export class ConfigDB {
    static data = {
      settings: {
        layout_type: 'ltr',
        layout_class: 'compact-wrapper',
        sidebar: {
          iconType: 'stroke',
        },
        sidebar_setting: 'default-sidebar',
      },
      color: {
        primary_color:'#4580f7',
        secondary_color: '#48A3D7',
        mix_background_layout: 'dark-sidebar',
      }
    };
  }
  export default ConfigDB;